import { createAsyncThunk } from '@reduxjs/toolkit';

import { RootState } from 'rootReducer';

import editEventThunk from './thunks/editEvent';
import { inputSliceActions } from './inputSlice';
export const editEvent = editEventThunk;

export const setActiveSelectValue = createAsyncThunk('input/setActiveSelectValue', (payload: any, thunkAPI) => {
  const { dispatch } = thunkAPI;
  const rootState = thunkAPI.getState() as RootState;
  const inputState = rootState.input;
  const { activeSelectId, selects } = inputState;

  const isForGoalScorer = selects.goalScorer.id === activeSelectId;
  const isForAssists = selects.assist.id === activeSelectId;

  if (isForGoalScorer) {
    if (selects?.assist?.value && selects.assist.value === payload) {
      return;
    }
  }

  if (isForAssists) {
    if (selects?.goalScorer?.value && selects.goalScorer.value === payload) {
      return;
    }
  }

  dispatch(inputSliceActions.setSelectValue(payload));

  for (const key in inputState.selects) {
    const select = inputState.selects[key];

    if (select.id === activeSelectId) {
      switch (key) {
        case 'goalScorer': {
          dispatch(inputSliceActions.setActiveSelect(selects.assist.id));
          break;
        }
        case 'playerFouled': {
          dispatch(inputSliceActions.setActiveSelect(selects.playerOffence.id));
          break;
        }
        case 'playerOffence': {
          dispatch(inputSliceActions.setActiveSelect(selects.playerPenaltyTaker.id));
          break;
        }
      }
    }
  }
});
